import Head from "next/head";
import React from "react";
import { PageHeader } from "@business-finland/wif-ui-lib/dist/PageHeader";

import useEmployerSite from "@/contexts/EmployerSiteContext";
import { META_TITLE_SUFFIX } from "@/constants/app";
import HtmlParser from "@/components/HtmlParser";
import { jcrMultiFieldToArray } from "@/util/magnolia";
import { ServicesListWithFilters } from "./ServicesListWithFilters";
import { NodeWithIsPreview, SmartEditableArea } from "@/util/SmartEditableArea";

export function ServicesFiltersPage(
  props: NodeWithIsPreview<Wif.Mgnl.ServicesFiltersPage>
): JSX.Element | null {
  const { title, metaDescription, metadata, main, isPreview } = props;
  const {
    heading,
    leadText,
    categoriesDir,
    displayOnlyChildrenPages,
    filtersTitle,
    filtersClear,
  } = props;
  const { isEmployerSite } = useEmployerSite();

  const categories =
    categoriesDir && typeof categoriesDir === "object"
      ? jcrMultiFieldToArray(categoriesDir)
      : [];

  return (
    <>
      <Head>
        <title>{title + META_TITLE_SUFFIX}</title>
        <meta name="description" content={metaDescription} />
      </Head>

      <PageHeader
        heading={heading}
        leadText={<HtmlParser html={leadText} />}
        backgroundColor={isEmployerSite ? "lightBlue" : "blue"}
      />
      <ServicesListWithFilters
        categories={categories}
        displayOnlyChildrenPages={displayOnlyChildrenPages}
        currentPagePath={metadata?.["@path"] || props["@path"]}
        wording={{
          title: filtersTitle,
          clearFilters: filtersClear,
        }}
      />

      <SmartEditableArea isPreview={isPreview} slotNode={main} />
    </>
  );
}
